/**
 * Copyright © 2024-2026 Entangled Harmony Labs, LLC
 * All Rights Reserved. Proprietary and Confidential.
 */
// src/config/api.config.ts

// src/config/api.config.ts
export const API_CONFIG = {
  //API_BASE_URL: process.env.REACT_APP_API_BASE_URL || 'https://notefinder-api-prod.azurewebsites.net',
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL || 'https://localhost:7095',
  BOT_BASE_URL: process.env.REACT_APP_BOT_BASE_URL || 'https://guitarlessons-bot-app.azurewebsites.net',
};
